/* 🤖 this file was generated by svg-to-ts */
export const svgCross: {
    name: "cross";
    data: string;
} = {
    name: "cross",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__cross" class="ng__path-cross" viewBox="0 0 8 8"><g fill="none" fill-rule="evenodd" stroke-linecap="round" transform="translate(-1172 -43) translate(1172 43)"><path d="M.5.5 7.5 7.5"/><path d="M.5.5 7.5 7.5" transform="matrix(-1 0 0 1 8 0)"/></g></symbol></svg>`,
};
